module.exports = __webpack_public_path__ + "img/ic_digital_camera_blue.6e624347.svg";